var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGithubActionsLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    rx: 60,
    fill: "#F4F4ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.0652 43C94.3271 43 109.13 57.8034 109.13 76.0652C109.13 94.3271 94.3271 109.13 76.0652 109.13C57.8034 109.13 43 94.3271 43 76.0652C43 57.8034 57.8034 43 76.0652 43Z",
    stroke: "#2088FF",
    strokeWidth: 7.34783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.826 109.13C136 109.13 145.87 119 145.87 131.174C145.87 143.348 136 153.217 123.826 153.217C111.652 153.217 101.783 143.348 101.783 131.174C101.783 119 111.652 109.13 123.826 109.13Z",
    stroke: "#2088FF",
    strokeWidth: 7.34783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.826 167.913C136 167.913 145.87 177.782 145.87 189.957C145.87 202.131 136 212 123.826 212C111.652 212 101.783 202.131 101.783 189.957C101.783 177.782 111.652 167.913 123.826 167.913Z",
    stroke: "#2088FF",
    strokeWidth: 7.34783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.957 167.913C202.131 167.913 212 177.782 212 189.957C212 202.131 202.131 212 189.957 212C177.782 212 167.913 202.131 167.913 189.957C167.913 177.782 177.782 167.913 189.957 167.913Z",
    stroke: "#79B8FF",
    strokeWidth: 7.34783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M131.308 126.056L120.032 137.317L114.555 131.859",
    stroke: "#2088FF",
    strokeWidth: 7.34783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.957 109.13C202.131 109.13 212 119 212 131.174C212 143.348 202.131 153.217 189.957 153.217C177.782 153.217 167.913 143.348 167.913 131.174C167.913 119 177.782 109.13 189.957 109.13Z",
    stroke: "#2088FF",
    strokeWidth: 7.34783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M197.438 126.056L186.162 137.317L180.686 131.859",
    stroke: "#2088FF",
    strokeWidth: 7.34783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0435 64.3532C65.0435 61.4617 68.2291 59.7035 70.6756 61.2446L89.461 73.0784C91.7583 74.5255 91.7462 77.8786 89.439 79.3093L70.6534 90.9574C68.206 92.4747 65.0435 90.7145 65.0435 87.8349V64.3532Z",
    stroke: "#2088FF",
    strokeWidth: 7.34783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3911 109.13V164.239C72.3911 178.442 84.0639 189.956 98.1085 189.956H101.782",
    stroke: "#2088FF",
    strokeWidth: 7.34783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M101.595 134.847C103.624 134.847 105.269 133.203 105.269 131.173C105.269 129.144 103.624 127.5 101.595 127.5V134.847ZM68.7173 109.259C68.7173 123.391 80.1736 134.847 94.3054 134.847V127.5C84.2315 127.5 76.0651 119.333 76.0651 109.259H68.7173ZM94.3054 134.847H101.595V127.5H94.3054V134.847Z",
    fill: "#2088FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M146.071 131.174H167.911",
    stroke: "#2088FF",
    strokeWidth: 7.34783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.478 186.283C118.505 186.283 120.152 187.929 120.152 189.957C120.152 191.987 118.505 193.631 116.478 193.631C114.451 193.631 112.804 191.987 112.804 189.957C112.804 187.929 114.451 186.283 116.478 186.283Z",
    fill: "#79B8FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.174 186.283C133.201 186.283 134.848 187.929 134.848 189.957C134.848 191.987 133.201 193.631 131.174 193.631C129.147 193.631 127.5 191.987 127.5 189.957C127.5 187.929 129.147 186.283 131.174 186.283Z",
    fill: "#79B8FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M164.257 189.981L160.537 190.103",
    stroke: "#79B8FF",
    strokeWidth: 7.34783,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubActionsLight);
export default __webpack_public_path__ + "static/media/GithubActions-Light.f2bbeded0efeeeedf53ca1616b94b6b3.svg";
export { ForwardRef as ReactComponent };